import { render, staticRenderFns } from "./loadSkeleton.vue?vue&type=template&id=1b266c49&scoped=true&"
var script = {}
import style0 from "./loadSkeleton.vue?vue&type=style&index=0&id=1b266c49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b266c49",
  null
  
)

export default component.exports